import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { clearFormatting, findKeymapByDescription, tooltip } from '@atlaskit/editor-common/keymaps';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { separatorStyles, wrapperStyle } from '@atlaskit/editor-common/styles';
import { DropdownMenuWithKeyboardNavigation as DropdownMenu } from '@atlaskit/editor-common/ui-menu';
import { akEditorMenuZIndex } from '@atlaskit/editor-shared-styles';
import TextIcon from '@atlaskit/icon/core/text';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { ThemeMutationObserver } from '@atlaskit/tokens';
import { NORMAL_TEXT } from '../../block-types';
import { BlockTypeButton } from './blocktype-button';
import { blockTypeMenuItemStyle, floatingToolbarWrapperStyle, keyboardShortcut, keyboardShortcutSelect } from './styled';
var buttonWrapperStyles = xcss({
  flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
var ToolbarBlockType = /*#__PURE__*/function (_React$PureComponent) {
  function ToolbarBlockType() {
    var _this;
    _classCallCheck(this, ToolbarBlockType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToolbarBlockType, [].concat(args));
    _defineProperty(_this, "state", {
      active: false,
      isOpenedByKeyboard: false,
      typographyTheme: undefined,
      observer: null
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(_this, "onOpenChange", function (attrs) {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        active: attrs.isOpen,
        isOpenedByKeyboard: attrs.isOpenedByKeyboard
      }));
    });
    _defineProperty(_this, "handleTriggerClick", function () {
      _this.onOpenChange({
        isOpen: !_this.state.active,
        isOpenedByKeyboard: false
      });
    });
    _defineProperty(_this, "handleTriggerByKeyboard", function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        _this.onOpenChange({
          isOpen: !_this.state.active,
          isOpenedByKeyboard: true
        });
      }
    });
    _defineProperty(_this, "createItems", function () {
      var _this$props = _this.props,
        formatMessage = _this$props.intl.formatMessage,
        currentBlockType = _this$props.currentBlockType,
        availableBlockTypesInDropdown = _this$props.availableBlockTypesInDropdown,
        formattingIsPresent = _this$props.formattingIsPresent;
      var items = (availableBlockTypesInDropdown !== null && availableBlockTypesInDropdown !== void 0 ? availableBlockTypesInDropdown : []).map(function (blockType, index) {
        var isActive = currentBlockType === blockType;
        var tagName = blockType.tagName || 'p';
        var Tag = tagName;
        var defaultMessage = Array.isArray(blockType.title.defaultMessage) ? blockType.title.defaultMessage.find(function (message) {
          return 'value' in message;
        }) : blockType.title.defaultMessage;
        var description = typeof defaultMessage === 'string' ? defaultMessage : defaultMessage && 'value' in defaultMessage ? defaultMessage.value : '';
        var keyMap = findKeymapByDescription(description);
        var icon = blockType === null || blockType === void 0 ? void 0 : blockType.icon;
        var item = {
          content:
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          jsx("div", {
            css: blockTypeMenuItemStyle(tagName, isActive, _this.state.typographyTheme)
          }, jsx(Tag, null, formatMessage(blockType.title))),
          value: blockType,
          'aria-label': tooltip(keyMap, formatMessage(blockType.title)),
          key: "".concat(blockType.name, "-").concat(index),
          elemBefore: editorExperiment('platform_editor_controls', 'variant1') ? icon : undefined,
          elemAfter:
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          jsx("div", {
            css: [keyboardShortcut, isActive && keyboardShortcutSelect]
          }, tooltip(keyMap)),
          isActive: isActive
        };
        return item;
      });
      if ((availableBlockTypesInDropdown !== null && availableBlockTypesInDropdown !== void 0 ? availableBlockTypesInDropdown : []).map(function (blockType) {
        return blockType.name;
      }).includes('blockquote') && editorExperiment('platform_editor_controls', 'control')) {
        var clearFormattingItem = {
          content: jsx("div", null, jsx("p", null, toolbarMessages.clearFormatting.defaultMessage)),
          value: {
            name: 'clearFormatting'
          },
          'aria-label': tooltip(clearFormatting, toolbarMessages.clearFormatting.defaultMessage),
          key: 'clear-formatting',
          elemAfter:
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          jsx("div", {
            css: [keyboardShortcut]
          }, tooltip(clearFormatting)),
          isActive: false,
          isDisabled: currentBlockType === NORMAL_TEXT && !formattingIsPresent
        };
        return [{
          items: items
        }, {
          items: [clearFormattingItem]
        }];
      }
      return [{
        items: items
      }];
    });
    _defineProperty(_this, "handleSelectBlockType", function (_ref) {
      var item = _ref.item,
        _ref$shouldCloseMenu = _ref.shouldCloseMenu,
        shouldCloseMenu = _ref$shouldCloseMenu === void 0 ? true : _ref$shouldCloseMenu;
      var blockType = item.value;
      if (blockType.name === 'blockquote') {
        _this.props.wrapBlockQuote(blockType.name);
      } else {
        if (blockType.name === 'clearFormatting') {
          _this.props.clearFormatting();
        } else {
          var _this$props$currentBl;
          var fromBlockQuote = ((_this$props$currentBl = _this.props.currentBlockType) === null || _this$props$currentBl === void 0 ? void 0 : _this$props$currentBl.name) === 'blockquote';
          _this.props.setTextLevel(blockType.name, fromBlockQuote);
        }
      }
      if (shouldCloseMenu) {
        _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
          active: false
        }));
      }
    });
    return _this;
  }
  _inherits(ToolbarBlockType, _React$PureComponent);
  return _createClass(ToolbarBlockType, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var observer = new ThemeMutationObserver(function (_ref2) {
        var typography = _ref2.typography;
        if (typography !== _this2.state.typographyTheme) {
          _this2.setState({
            typographyTheme: typography
          });
        }
      });
      this.setState({
        observer: observer
      });
      observer.observe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state$observer;
      (_this$state$observer = this.state.observer) === null || _this$state$observer === void 0 || _this$state$observer.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        active = _this$state.active,
        isOpenedByKeyboard = _this$state.isOpenedByKeyboard;
      var _this$props2 = this.props,
        popupsMountPoint = _this$props2.popupsMountPoint,
        popupsBoundariesElement = _this$props2.popupsBoundariesElement,
        popupsScrollableElement = _this$props2.popupsScrollableElement,
        isSmall = _this$props2.isSmall,
        isReducedSpacing = _this$props2.isReducedSpacing,
        currentBlockType = _this$props2.currentBlockType,
        blockTypesDisabled = _this$props2.blockTypesDisabled,
        _this$props2$availabl = _this$props2.availableBlockTypes,
        availableBlockTypes = _this$props2$availabl === void 0 ? [] : _this$props2$availabl,
        _this$props2$availabl2 = _this$props2.availableBlockTypesInDropdown,
        availableBlockTypesInDropdown = _this$props2$availabl2 === void 0 ? [] : _this$props2$availabl2,
        shouldUseDefaultRole = _this$props2.shouldUseDefaultRole,
        formatMessage = _this$props2.intl.formatMessage,
        api = _this$props2.api;
      var isHeadingDisabled = !availableBlockTypes.some(function (blockType) {
        return blockType.nodeName === 'heading';
      });
      if (isHeadingDisabled) {
        return null;
      }
      var blockTypeTitles = availableBlockTypesInDropdown.filter(function (blockType) {
        return blockType.name === (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name);
      }).map(function (blockType) {
        return blockType.title;
      });
      var defaultIcon = jsx(TextIcon, {
        label: ""
      });
      var currentIcon = currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.icon;
      if (!this.props.isDisabled && !blockTypesDisabled) {
        var items = this.createItems();
        var button = jsx(BlockTypeButton, {
          isSmall: isSmall,
          isReducedSpacing: isReducedSpacing,
          selected: active,
          disabled: false,
          title: blockTypeTitles[0],
          onClick: this.handleTriggerClick,
          onKeyDown: this.handleTriggerByKeyboard,
          formatMessage: formatMessage,
          "aria-expanded": active,
          blockTypeName: currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name,
          blockTypeIcon: currentIcon || defaultIcon
        });
        return jsx("span", {
          css: editorExperiment('platform_editor_blockquote_in_text_formatting_menu', true) ?
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          [wrapperStyle, floatingToolbarWrapperStyle] :
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          wrapperStyle
        }, jsx(DropdownMenu, {
          items: items,
          onOpenChange: this.onOpenChange,
          onItemActivated: this.handleSelectBlockType,
          isOpen: active,
          mountTo: popupsMountPoint,
          boundariesElement: popupsBoundariesElement,
          scrollableElement: popupsScrollableElement,
          zIndex: akEditorMenuZIndex,
          fitHeight: 360,
          fitWidth: 106,
          section: {
            hasSeparator: true
          },
          shouldUseDefaultRole: shouldUseDefaultRole
          // hasSeparator={true}
          ,
          shouldFocusFirstItem: function shouldFocusFirstItem() {
            if (isOpenedByKeyboard) {
              // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
              _this3.setState(_objectSpread(_objectSpread({}, _this3.state), {}, {
                isOpenedByKeyboard: false
              }));
            }
            return isOpenedByKeyboard;
          }
        }, jsx(Box, {
          xcss: buttonWrapperStyles
        }, button)), !(api !== null && api !== void 0 && api.primaryToolbar) && jsx("span", {
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          css: separatorStyles
        }));
      }
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("span", {
          css: wrapperStyle
        }, jsx(BlockTypeButton, {
          isSmall: isSmall,
          isReducedSpacing: isReducedSpacing,
          selected: active,
          disabled: true,
          title: blockTypeTitles[0],
          onClick: this.handleTriggerClick,
          onKeyDown: this.handleTriggerByKeyboard,
          formatMessage: formatMessage,
          "aria-expanded": active,
          blockTypeName: currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name,
          blockTypeIcon: currentIcon || defaultIcon
        }), !(api !== null && api !== void 0 && api.primaryToolbar) && jsx("span", {
          // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
          css: separatorStyles
        }))
      );
    }
  }]);
}(React.PureComponent);
export default injectIntl(ToolbarBlockType);